import {
  GET_MOORINGLINEHISTORY,
  SHOW_MOORINGLINEHISTORY_LOADING,
  MOORINGLINEHISTORY_ERROR,
  GET_MOORINGLINEHISTORY_DETAILS,
  SHOW_EDIT_MOORINGLINEHISTORY_LOADING,
  EDIT_MOORINGLINEHISTORY,
  DELETE_MOORINGLINEHISTORY,
  CREATE_MOORINGLINEHISTORY,
} from '../actions/types';

/**
 * maco-magsael-sc-1000: Logbook - add mooring log in list of logbooks
 */

const initialState = {
  mooringlinehistorylist: [],
  mooringlinehistoryID: null,
  mooringlinehistoryDetails: null,
  mooringlinehistoryLoading: false,
  editMooringlinehistoryLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MOORINGLINEHISTORY_LOADING:
      return {
        ...state,
        mooringlinehistoryLoading: true,
      };
    case SHOW_EDIT_MOORINGLINEHISTORY_LOADING:
      return {
        ...state,
        editMooringlinehistoryLoading: true,
      };
    case GET_MOORINGLINEHISTORY:
      return {
        ...state,
        mooringlinehistorylist: payload,
        mooringlinehistoryLoading: false,
      };
    case CREATE_MOORINGLINEHISTORY:
      return {
        ...state,
        mooringlinehistorylist: [payload, ...state.mooringlinehistorylist],
        editMooringlinehistoryLoading: false,
      };
    case EDIT_MOORINGLINEHISTORY:
      return {
        ...state,
        mooringlinehistorylist: state.mooringlinehistorylist.map((item) =>
          item._id === payload._id
            ? {
                ...item,
                name: payload.name,
              }
            : item
        ),
        editMooringlinehistoryLoading: false,
      };
    case GET_MOORINGLINEHISTORY_DETAILS:
      return {
        ...state,
        mooringlinehistoryDetails: payload,
      };
    case DELETE_MOORINGLINEHISTORY:
      return {
        ...state,
        mooringlinehistorylist: state.mooringlinehistorylist.filter(
          (item) => item._id !== payload
        ),
        editMooringlinehistoryLoading: false,
        mooringlinehistoryLoading: false,
      };
    case MOORINGLINEHISTORY_ERROR:
      return {
        ...state,
        error: payload,
        mooringlinehistoryLoading: false,
      };
    default:
      return state;
  }
}
